import { HStack, Stack } from '@talos/kyoko';
import styled, { css } from 'styled-components';

export const PresetListRowHoverRoot = styled(Stack)<{ $showDefaultSlotAlways?: boolean }>`
  width: 100%;
  min-height: 100%;
  height: 100%;
  flex: 1;
  justify-content: center;

  & .preset-default-slot {
    visibility: ${({ $showDefaultSlotAlways }) => ($showDefaultSlotAlways ? 'visible' : 'hidden')};
    pointer-events: ${({ $showDefaultSlotAlways }) => ($showDefaultSlotAlways ? 'auto' : 'none')};
  }

  ${({ $showDefaultSlotAlways }) =>
    !$showDefaultSlotAlways &&
    css`
      &:hover .preset-default-slot,
      &:focus-within .preset-default-slot,
      & .preset-default-slot[data-visible='true'] {
        visibility: visible;
        pointer-events: auto;
      }
    `}
`;

export const PresetListItemRow = styled(HStack)`
  width: 100%;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing8};
`;
